@layer reset, defaults, sideNav, topNav, mobileNav, desktop, mobile, hover, focus;

@layer reset {
  :host * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
}

@layer defaults {
  :host {
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: flex-end;

    .gcds-nav-group__trigger {
      display: flex;
      align-items: center;
      width: 100%;
      font: var(--gcds-nav-group-font);
      text-align: left;
      padding: var(--gcds-nav-group-trigger-padding);
      background: transparent;
      color: var(--gcds-nav-group-trigger-text);
      border: 0;
      cursor: pointer;

      &[aria-expanded='false'] + .gcds-nav-group__list {
        display: none;
      }
    }

    .gcds-nav-group__trigger-desc {
      display: none;
    }

    ul {
      list-style: none;
    }
  }
}

@layer sideNav {
  :host .gcds-trigger--expandable {
    font-weight: var(--gcds-nav-group-side-nav-trigger-font-weight);
    margin-block-end: var(--gcds-nav-group-side-nav-trigger-margin);

    gcds-icon {
      margin-inline-end: var(--gcds-nav-group-side-nav-trigger-icon-margin);
    }
  }
}

@layer topNav {
  :host .gcds-trigger--dropdown {
    padding: var(--gcds-nav-group-top-nav-trigger-padding);
    text-decoration: underline solid currentColor
      var(--gcds-nav-group-top-nav-trigger-decoration-thickness);
    text-underline-offset: var(
      --gcds-nav-group-top-nav-trigger-underline-offset
    );
    text-decoration-color: transparent;
    transition: all 0.25s ease-in-out;

    &[aria-expanded='true'] {
      background-color: var(
        --gcds-nav-group-top-nav-trigger-expanded-background-color
      );
    }

    gcds-icon {
      order: 2;
      margin-inline-start: var(--gcds-nav-group-top-nav-trigger-icon-margin);
    }
  }
}

@layer mobileNav {
  :host(.gcds-mobile-nav) {
    width: 100%;

    .gcds-trigger--expandable {
      text-align: center;
      flex-direction: row-reverse;
      justify-content: center;
      margin-block-start: var(--gcds-nav-group-mobile-trigger-margin);
      color: var(--gcds-nav-group-mobile-trigger-text);
      border: var(--gcds-nav-group-mobile-trigger-border-width) solid
        currentColor;
      border-radius: var(--gcds-nav-group-mobile-trigger-border-radius);

      gcds-icon {
        display: none;
      }
    }
  }

  :host([open].gcds-mobile-nav) {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    background-color: var(--gcds-nav-group-mobile-background);
    padding: var(--gcds-nav-group-mobile-padding) !important;
  }
}

/* Note: viewport specific style decision */
@layer desktop {
  @media only screen and (width >= 64em) {
    :host {
      .gcds-nav-group__trigger {
        max-width: var(--gcds-nav-group-trigger-max-width);
      }

      .gcds-nav--expandable {
        padding-inline-start: var(--gcds-nav-group-side-nav-dropdown-padding);
      }

      .gcds-nav--dropdown {
        z-index: 1;
        position: absolute;
        top: 100%;
        left: 0;
        width: var(--gcds-nav-group-top-nav-dropdown-width);
        background-color: var(--gcds-nav-group-top-nav-dropdown-background);
        margin-block-start: var(--gcds-spacing-200);
        padding: var(--gcds-nav-group-top-nav-dropdown-padding);
        box-shadow: var(--gcds-nav-group-top-nav-dropdown-box-shadow);
        border-radius: var(--gcds-border-radius-md);

        &.dropdown-right {
          left: auto;
          right: 0;
        }
      }
    }

    :host(.gcds-mobile-nav) {
      > .gcds-nav--expandable {
        display: block;
        padding: 0;
      }

      .gcds-trigger--expandable {
        display: none;
      }
    }

    :host(.gcds-mobile-nav-topnav) > .gcds-nav--expandable {
      display: flex;
    }
  }
}

/* Note: viewport specific style decision */
@layer mobile {
  @media only screen and (width < 64em) {
    :host(.gcds-mobile-nav) > .gcds-nav--expandable {
      margin: var(--gcds-nav-group-mobile-list-margin);
    }

    :host([open]:not(.gcds-mobile-nav)) .gcds-nav-group__list {
      padding-inline-start: var(--gcds-nav-group-side-nav-dropdown-padding);
    }
  }

  @media only screen and (48em < width < 64em) {
    :host(.gcds-mobile-nav) .gcds-trigger--expandable {
      width: auto;
      align-self: flex-start;
    }
  }
}

@layer hover {
  @media (hover: hover) {
    :host {
      .gcds-nav-group__trigger:hover {
        color: var(--gcds-nav-group-trigger-hover-text);
      }

      /* Top-nav trigger */
      .gcds-trigger--dropdown:hover {
        color: var(--gcds-nav-group-top-nav-trigger-hover-text);
        text-decoration-color: var(--gcds-nav-group-top-nav-trigger-hover-text);
        text-decoration-thickness: var(
          --gcds-nav-group-top-nav-trigger-hover-decoration-thickness
        );
      }

      /* Side-nav trigger */
      .gcds-trigger--expandable:hover {
        background-color: var(
          --gcds-nav-group-side-nav-trigger-hover-background
        );
      }
    }
  }
}

@layer focus {
  :host .gcds-nav-group__trigger:focus {
    background-color: var(--gcds-nav-group-trigger-focus-background);
    color: var(--gcds-nav-group-trigger-focus-text);
    outline: var(--gcds-nav-group-trigger-focus-outline);
    outline-offset: var(--gcds-nav-group-trigger-focus-outline-offset);
    border-color: var(--gcds-nav-group-trigger-focus-background);
    text-decoration: none;
    border-radius: var(--gcds-nav-group-trigger-focus-border-radius);
    box-shadow: var(--gcds-nav-group-trigger-focus-box-shadow);
  }
}
